import KendoTabStripMixin from './KendoTabStripMixin'

export default {
    name: 'kendo-tabstrip',
    mixins: [ KendoTabStripMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoTabStrip/index.js